import { jsxs as r, jsx as l, Fragment as k } from "react/jsx-runtime";
import { useRef as T, useState as H } from "react";
import { c as g } from "./index-SYE1cn5_.js";
import { L as I } from "./Label-DMBnN1_E.js";
import { T as L } from "./Text-D6i4LEWL.js";
import { B as U } from "./Button-CrmHmqjQ.js";
import { X as O } from "./XMarkIcon-DYnAhe7C.js";
const B = "_fileUploadContainer_jyqwx_1", E = "_fileUpload__input_jyqwx_7", R = "_fileUpload__dropzone_jyqwx_14", S = "_fileUpload__files_jyqwx_35", X = "_fileUpload__file_jyqwx_35", A = "_fileUpload__fileHeader_jyqwx_55", K = "_fileUpload__fileName_jyqwx_61", M = "_fileUpload__image_jyqwx_67", V = "_fileUpload__video_jyqwx_67", a = {
  fileUploadContainer: B,
  fileUpload__input: E,
  fileUpload__dropzone: R,
  "fileUpload__dropzone--dragging": "_fileUpload__dropzone--dragging_jyqwx_28",
  fileUpload__files: S,
  fileUpload__file: X,
  fileUpload__fileHeader: A,
  fileUpload__fileName: K,
  fileUpload__image: M,
  fileUpload__video: V
}, ee = ({
  id: _,
  label: m,
  className: u,
  clarificationText: h = "Arrastra y suelta tu archivo aquí",
  buttonText: v = "Seleccionar archivo",
  buttonUpperCase: y = !0,
  required: s,
  onChange: d,
  onDelete: p,
  multiple: j = !1,
  accept: x,
  value: n = [],
  setValue: D,
  ...w
}) => {
  const o = T(null), [N, t] = H(!1), f = () => {
    o.current && o.current.click();
  }, c = (e) => {
    d && d(e);
  }, q = (e) => {
    e.preventDefault(), e.stopPropagation(), t(!0);
  }, z = (e) => {
    e.preventDefault(), e.stopPropagation(), t(!1);
  }, C = (e) => {
    e.preventDefault(), e.stopPropagation(), t(!1), e.dataTransfer.files && e.dataTransfer.files.length > 0 && o.current && (o.current.files = e.dataTransfer.files, o.current.files && c({
      target: { files: o.current.files }
    }));
  }, b = (e) => {
    e.preventDefault(), e.stopPropagation();
  }, F = (e) => {
    p && p(e);
    const i = [...n];
    i.splice(e, 1), D(i);
  };
  return /* @__PURE__ */ r("div", { className: a.fileUploadContainer, children: [
    /* @__PURE__ */ l(I, { htmlFor: _, required: s, children: m }),
    /* @__PURE__ */ l(
      "input",
      {
        ref: o,
        type: "file",
        id: _,
        required: s,
        onChange: c,
        multiple: j,
        ...w,
        className: g(a.fileUpload__input, u),
        accept: x
      }
    ),
    /* @__PURE__ */ r(
      "div",
      {
        className: g(a.fileUpload__dropzone, {
          [a["fileUpload__dropzone--dragging"]]: N
        }),
        onClick: f,
        onKeyPress: f,
        role: "button",
        tabIndex: 0,
        onDragEnter: q,
        onDragOver: b,
        onDragLeave: z,
        onDrop: C,
        children: [
          n.length === 0 && /* @__PURE__ */ r(k, { children: [
            /* @__PURE__ */ l(L, { variant: "body-2", children: h }),
            /* @__PURE__ */ l(
              U,
              {
                variant: "outline",
                color: "secondary",
                size: "md",
                type: "button",
                upperCase: y,
                children: v
              }
            )
          ] }),
          n.length > 0 && /* @__PURE__ */ l("div", { className: a.fileUpload__files, children: n.map((e, i) => /* @__PURE__ */ r("div", { className: a.fileUpload__file, children: [
            /* @__PURE__ */ l("div", { className: a.fileUpload__fileHeader, children: /* @__PURE__ */ l(
              U,
              {
                variant: "flat",
                isOnlyIcon: !0,
                type: "button",
                onClick: (P) => {
                  P.stopPropagation(), F(i);
                },
                size: "md",
                children: /* @__PURE__ */ l(O, {})
              }
            ) }),
            (e.includes(".png") || e.includes(".jpeg") || e.includes(".jpg")) && /* @__PURE__ */ l(
              "img",
              {
                src: e,
                alt: e,
                className: a.fileUpload__image
              }
            )
          ] }, i)) })
        ]
      }
    )
  ] });
};
export {
  ee as F
};
